import { render, staticRenderFns } from "./nxMobileSelect.vue?vue&type=template&id=08707a7e&scoped=true&"
import script from "./nxMobileSelect.vue?vue&type=script&lang=js&"
export * from "./nxMobileSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08707a7e",
  null
  
)

export default component.exports